import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const useStyles = makeStyles((theme) =>
  createStyles({
    lblPercent: {
      marginTop: 32,
      flexGrow: 1,
      textAlign: "right",
      fontSize: 13,
    },
    tooltip: {
      position: "absolute",
      top: "8px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "5px 10px",
      borderRadius: "4px",
      fontSize: "14px",
      whiteSpace: "nowrap",
    },
  })
);

const PhotoShootAssetTypeNttFt = ({ dataPhotoShootByAsset }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const arrNtt = Array.isArray(dataPhotoShootByAsset) ? dataPhotoShootByAsset : [];

    // 会社指定があればそれを優先
    let chosen = arrNtt;
    setIsLoading(chosen.length > 0 && chosen[0]?.subType === "loading");
    setRows(chosen);
  }, [dataPhotoShootByAsset]);

  const displayRows = isLoading
    ? rows
    : rows.filter((item) => (Number(item.CNT) || 0) > 0);

  // データなし（loading ではない）
  if (!isLoading && displayRows.length === 0) {
    return <Typography variant="body2" color="textSecondary">データがありません</Typography>;
  }

  const total = !isLoading
    ? rows.reduce((sum, it) => sum + (Number(it.CNT) || 0), 0)
    : null;
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          {/* 左側：合計 */}
          <Typography variant="caption" className={classes.summaryText}>
            {isLoading ? "loading" : `合計：${total.toLocaleString()}`}
          </Typography>

          {/* 右側：注釈 */}
          <Typography variant="caption" className={classes.captionNote}>
            ※ すべてレビューOKの件数です
          </Typography>
        </Grid>
      </Grid>

      <Grid item sm={12}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              {displayRows.map((item) => (
                <Grid key={item.subType || item.label} item xs={12} sm={6} md={3} lg={2}>
                  <StatBoxSlim
                    title={item.label || item.subType || "-"}
                    value={item.subType === "loading" ? "loading" : (item.CNT ?? "-")}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

PhotoShootAssetTypeNttFt.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dateRange: state.page.dateRangePicTree,
  dataPhotoShootByAsset: state.pictreeNttFt.dataPhotoShootByAsset,
});

const mapDispatchToProps = (dispatch) => ({
  //setCurrentModule: (param) => dispatch(setCurrentModule(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(PhotoShootAssetTypeNttFt));
